module.exports = __webpack_public_path__ + "img/boxed-10.d420bf6b.jpg";